
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 15","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.957 3.293l-7.602 7.601L1 14.013c-.027.218.027.41.191.547.137.164.329.218.547.191l3.117-.355 7.602-7.602-3.5-3.5zm5.66-.52c.246.274.383.575.383.93 0 .383-.137.684-.383.93L13.06 6.19l-3.5-3.5 1.558-1.558c.246-.246.547-.383.93-.383.355 0 .656.137.93.383l1.64 1.64z"}})])
          )
        }
      }
    